import Header from "./components/Header"
import Main from "./pages/Main"
import Directories from "./pages/Directories"
import FilesProvider from "./fmanlibs/FilesProvider"
import SelectionProvider from "./fmanlibs/SelectionProvider"
import Resizer from "./gui/Resizer/Resizer"

export default function App(){
    return <>
        <Header/>
        <div className="body flex1 flex">
            <Resizer min={64} max={300}><Directories/></Resizer>
            <SelectionProvider><FilesProvider><Main/></FilesProvider></SelectionProvider>
        </div>
    </>
}